import React, { useState } from 'react';

import { useMount } from '../../../../hooks';
import { ProTabBarToaster } from './ProTabBarToaster';

type ProTabBarToasterContainerProps = {
  /** provider id */
  providerId: number | string,
};

const ProTabBarToasterContainer = ({
  providerId,
}: ProTabBarToasterContainerProps) => {
  const [showToaster, setShowToaster] = useState(false);
  const [toasterProps, setToasterProps] = useState({});

  useMount(() => {
    // not implemented -- removed the why add client toaster as part of fly-2609
    setShowToaster(false);
    setToasterProps({ providerId });
  });

  if (showToaster) {
    return (
      <ProTabBarToaster
        {...toasterProps}
      />
    );
  }

  return null;
};

export default ProTabBarToasterContainer;
